module.exports = __webpack_public_path__ + "img/6.526088b3.png";